// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"37974":"0b656ce115","63496":"63d5dcad55","66586":"66d4638d58","83763":"9c41a9de20"}[chunkId] + ".css";
};